'use client';
import React from 'react';
import Link from 'next/link';
// ※ 下記コンポーネントはそれぞれ実装済みであることを前提です。
import FeaturedJobs from '~/components/jobs/featured-jobs';
import FeaturedJob from '~/components/jobs/featured-job';
import { JobDetail } from '~/types/job-detail';
import ErrorBoundary from '~/components/error-boundary';

interface JobSameCompanyProps {
  job: JobDetail;
  sameCompanyJobs: JobDetail[];
  isMobile: boolean;
  isSignedIn: boolean;
  favoriteJobIds: number[];
}

const JobSameCompany: React.FC<JobSameCompanyProps> = ({
  job,
  sameCompanyJobs,
  isMobile,
  isSignedIn,
  favoriteJobIds,
}) => {
  // job が締め切り状態、または同企業求人が空の場合は何もレンダリングしない
  if (job.closing || sameCompanyJobs.length === 0) {
    return null;
  }

  return (
    <div className="c-panel --no-print -job-detail">
      {!isMobile ? (
        <>
          <div className="u-pl20 u-pr20">
            <h2 className="c-panel__header">この企業の募集中の求人</h2>
            <div className="c-panel__body">
              <FeaturedJobs
                jobs={sameCompanyJobs}
                displayJobSize={3}
                gtmClass="p-featured-jobs__item__buttons_btn"
                isMobile={isMobile}
                isSignedIn={isSignedIn}
                favoriteJobIds={favoriteJobIds}
              />
            </div>
          </div>
          <Link
            href={`/company/${job.company.id}`}
            className="c-panel__view-all u-fs16"
          >
            もっと見る
          </Link>
        </>
      ) : (
        <>
          <h2 className="c-panel__header -no-border u-fs-sp16 u-pl16">
            この企業の募集中の求人
          </h2>
          <div className="c-panel__body">
            <div className="p-featured-jobs">
              <div className="u-flex u-gap15">
                {sameCompanyJobs.map((jobItem) => (
                  <ErrorBoundary key={jobItem.id}>
                    <FeaturedJob
                      key={jobItem.id}
                      job={jobItem}
                      gtmClass="gtm-sp-job_featured-job_similarity"
                      isMobile={isMobile}
                      isSignedIn={isSignedIn}
                      favoriteJobIds={favoriteJobIds}
                    />
                  </ErrorBoundary>
                ))}
              </div>
            </div>
          </div>
          <Link
            href={`/company/${job.company.id}`}
            className="c-panel__view-all"
          >
            もっと見る
          </Link>
        </>
      )}
    </div>
  );
};

export default JobSameCompany;
